export default __webpack_public_path__ + "static/media/MSFT.db273383.png";